import React, {useEffect, useState} from "react";
import Select from "react-select";
import styled from "styled-components";
import {t} from "../../shared-services/translate";

export const MainContainer = (props) => {
  const {children, className = "", style} = props;

  return (
    <div
      className={`flex justify-content-center farmy-main-container ${className || ""}`}
      style={style}>
      {children}
    </div>
  );
};

export const Container = (props) => {
  const {children, className = "", style} = props;

  return <div className={`farmy-container ${className || ""}`} style={style}>
    {children}
  </div>;
};

const buttonSizeStyles = {
  custom: "",
  xl: `
    border-radius-xl
    padding-15
    font-size-h2
    font-weight-900
    `,
  lg: `
    border-radius-lg
    padding-10
    font-size-h3
    font-weight-900
  `,
  md: `
    border-radius-md
    padding-10
    font-size-body-bigger
    font-weight-900
  `,
  sm: `
    border-radius-sm
    padding-5
    font-size-body-small
  `
};

const buttonColorStyles = {
  default: `
    btn-default
  `,
  orange: `
    btn-orange
  `,
  green: `
    btn-green
  `,
  grey: `
    btn-grey
  `,
  transparent: `
    background-color-transparent
    border-none
  `,
  success: `
    btn-success
  `
};

export const FarmyButton = (props) => {
  const {color, size, disabled, onClick, children, className = "", style} = props;

  const colorStyles = buttonColorStyles[color] || "";
  const sizeStyles = buttonSizeStyles[size] || "";

  return <button
    onClick={onClick}
    disabled={disabled}
    className={`
      btn-farmy
      text-align-center
      ${colorStyles}
      ${sizeStyles}
      ${className}
    `}
    style={{...style}}
  >
    {children}
  </button>;
};

export const InnerPanel = styled.div.attrs(props => ({
  className:
    `border-light ${props.className}`,
  style: {
    backgroundColor: props.backgroundColor || "#eeeeee",
    borderRadius: props.borderRadius || "4px",
    borderColor: props.borderColor || "#eeeeee",
    transition: "background-color 300ms"
  }
}))``;

export const FmSimpleCheckbox = ({
                                   size = 15,
                                   onChange = () => {
                                   },
                                   checked
                                 }) => {
  const onInputChange = (e) => {
    const value = e.target?.checked;
    onChange(value);
  };

  return <input
    type="checkbox"
    onChange={onInputChange}
    style={{
      height: `${size}px`,
      width: `${size}px`,
      margin: 0,
      opacity: 0.5
    }}
    checked={checked || false}
  />;
};

/** Round Switch
 * @param values => [a, b] (default: [0, 1])
 * @param defaultValue
 * @param onSwitchClick
 * @param onSwitchChange
 * @param width => <int> in px (default: 40)
 * @param height => <int> in px
 * @param border => <int> in px
 * @param props => anything else (className, etc).
 * @returns {JSX.Element}
 */
export const FmRoundSwitch = ({
                                values = [0, 1],
                                defaultValue,
                                onSwitchClick,
                                onSwitchChange = () => {},
                                width = 40,
                                height,
                                border,
                                ...props
                              }) => {
  const [index, setIndex] = useState(values.includes(defaultValue) ? values.indexOf(defaultValue) : 0);
  const calculatedHeight = height || width / 1.8;
  const calculatedBorder = border || width / 12;

  const switchHeight = calculatedHeight + 1 - calculatedBorder * 2;

  onSwitchClick = onSwitchClick || (() => {switchValue()});

  const switchValue = () => {
    const newValue = values[index + 1] || values[0];

    setIndex(values.indexOf(newValue));
    onSwitchChange(newValue);
  };

  useEffect(() => {
    if (values.includes(defaultValue)) setIndex(values.indexOf(defaultValue));
  }, [defaultValue]);

  return <RoundSwitchWrapper
    onClick={onSwitchClick}
    sHeight={calculatedHeight}
    sWidth={width}
    border={border}
    switchHeight={switchHeight}
    calculatedBorder={calculatedBorder}
    className={`cursor-pointer ${props.className}`}
  >
    <div className={`switch-bg ${index && 'active'}`}>
      <div className={`switch ${index && 'active'}`}/>
    </div>
  </RoundSwitchWrapper>;
};

const RoundSwitchWrapper = styled.div`
  width: ${props => `${props.sWidth}px`};
  height: ${props => `${props.sHeight}px`};

  .switch-bg {
    position: relative;
    width: 100%;
    height: 100%;
    padding: ${props => `${props.calculatedBorder}px`};
    border-style: solid;
    border-color: #cccccc;
    background-color: #cccccc;
    border-width: ${props => `${props.calculatedBorder}px`};
    border-radius: ${props => `${props.sHeight}px`};
    transition: background-color 200ms, border-color 200ms;

    &.active {
      background: green;
      border-color: green;
    }

    .switch {
      width: ${props => `${props.switchHeight}px`};
      height: ${props => `${props.switchHeight}px`};
      position: absolute;
      left: ${props => `${props.calculatedBorder / 2}px`};
      bottom: 0;
      border-radius: 50%;
      background: white;
      transition: left 200ms;

      &.active {
        left: ${props => `calc(100% - ${props.switchHeight + props.calculatedBorder / 4}px)`}
      }
    }
  }
`;

export const FarmyCloseIcon = (props) => {
  const {
    className = "",
    style,
    ...additionalProps
  } = props;

  return (
    <img
      className={className}
      style={style}
      alt="close"
      src={"/icons/rx-cross-1.svg"}
      {...additionalProps}
    />
  );
};

/** FmDateDropdownSelector
 * all props except for the handler are boolean.
 * @param showDay
 * @param showMonth
 * @param showYear
 * @param showTime
 * @param limit
 * @param offset
 * @param onDateChange
 * @param initialDate
 * @returns {JSX.Element}
 * @constructor
 */
export const FmDateDropdownSelect = ({
                                       showDay = true,
                                       showMonth = true,
                                       showYear = true,
                                       showTime = false,
                                       limit = null,
                                       offset = null,
                                       initialDate = null,
                                       onDateChange = () => {
                                       }
                                     }) => {
  let initialData = {};

  const setInitialData = () => {
    const date = initialDate && new Date(initialDate);
    if (date && (date instanceof Date) && date.toString() !== 'Invalid Date') {
      initialData.day = date.getDate();
      initialData.month = date.getMonth();
      initialData.year = date.getFullYear();
    }
  }

  setInitialData();

  const [selectedDay, setDay] = useState(initialData.day);
  const [selectedMonth, setMonth] = useState(initialData.month);
  const [selectedYear, setYear] = useState(initialData.year);
  const [selectedTime, setTime] = useState(null);

  const [dayOptions, setDayOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);

  const [initialOptions, setInitialOptions] = useState({});

  const setupInitialOptions = () => {
    setInitialData();

    const options = initialData?.day ? {
      day: dayOptions.find(option => option.value === initialData.day),
      month: monthOptions.find(option => option.value === initialData.month),
      year: yearOptions.find(option => option.value === initialData.year)
    } : {};

    setInitialOptions(options);
  };

  const resetForm = () => {
    setDay(null);
    setMonth(null);
    setYear(null);
    setTime(null);
  }

  const getMonthDays = () => {
    const year = selectedYear || 1974;
    const month = selectedMonth || 0;

    const numOfDays = new Date(year, month + 1, 0).getDate();
    return Array(numOfDays).fill().map((e, index) => ({value: index + 1, label: index + 1}));
  };

  const getMonths = () => {
    const currentYear = selectedYear || 1974;

    const locale = window.I18n.locale || 'de';
    const numeric = createSequence(12);

    return numeric
      .map(m => {
        const date = new Date(currentYear, m - 1);
        return {value: date.getMonth(), label: date.toLocaleDateString(locale, {month: 'long'})};
      });
  };

  const getYears = () => {
    const currentYear = new Date().getFullYear();
    const initialYear = currentYear - 18;

    return createSequence(19, initialYear).reverse().map(year => ({value: year, label: year}));
  };

  const createSequence = (length, offset = 0) => {
    return Array(length).fill().map((e, index) => index + offset + 1);
  };

  const resetDayIfNecessary = () => {
    const lastPossibleDay = dayOptions[dayOptions.length - 1];
    if (selectedDay && selectedDay > lastPossibleDay?.value) setDay(lastPossibleDay.value);
  }

  const onDayChanged = (option) => {
    if (option?.value !== selectedDay) {
      setDay(option?.value);
    }
  };

  const onMonthChanged = (option) => {
    if (option?.value !== selectedMonth) {
      setMonth(option?.value);
    }
  };

  const onYearChanged = (option) => {
    if (option?.value !== selectedYear) {
      setYear(option?.value);
    }
  };

  useEffect(() => {
    setupInitialOptions();
    setMonthOptions(getMonths());
    setYearOptions(getYears());
  }, []);

  useEffect(() => {
    if (!initialDate) resetForm();
  }, [initialDate]);

  useEffect(() => {
    setDayOptions(getMonthDays());
  }, [selectedMonth, selectedYear, selectedDay]);

  useEffect(() => {
    resetDayIfNecessary()
  }, [dayOptions]);

  useEffect(() => {
    const newDate = (selectedDay && (selectedMonth || selectedMonth === 0) && selectedYear) ? new Date(Date.UTC(selectedYear, selectedMonth, selectedDay)) : null;
    onDateChange(newDate);
  }, [selectedDay, selectedMonth, selectedYear, dayOptions]);

  return <DateSelectWrapper>
    {showDay &&
      <Select
        className="flex-grow-05"
        onChange={onDayChanged}
        options={dayOptions}
        placeholder={t('datetime.day', 'Day')}
        value={dayOptions.filter(option => option.value === selectedDay) || initialOptions.day}
      />}
    {showMonth &&
      <Select
        className="flex-grow-1"
        onChange={onMonthChanged}
        options={monthOptions}
        placeholder={t('datetime.month', 'Month')}
        value={monthOptions.filter(option => option.value === selectedMonth) || initialOptions.month}
      />}
    {showYear &&
      <Select
        className="flex-grow-05"
        onChange={onYearChanged}
        options={yearOptions}
        placeholder={t('datetime.year', 'Year')}
        value={yearOptions.filter(option => option.value === selectedYear) || initialOptions.year}
      />}
  </DateSelectWrapper>;
};

const DateSelectWrapper = styled.div.attrs({
  className: 'flex gap-5'
})`
  .flex-grow-05 {
    flex-grow: 0.5;
  }

  .flex-grow-1 {
    flex-grow: 1;
  }
`;
